<template>
  <div>
    <v-dialog v-model="dialog" width="800">
      <v-card :disabled="disabledCard">
       <BarTitle :title="title" @close="dialog = false"></BarTitle>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                class="mt-4"
                outlined
                v-model="newTeamName"
                label="Nome da Equipe"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card outlined>
                <v-data-table
                  :loading="loading"
                  :item-key="'id'"
                  show-select
                  v-model="selectedEmployees"
                  dense
                  :headers="headers"
                  :items="employees"
                ></v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="syncWithChessgestao"
                text
                x-large
                color="primary"
                v-bind="attrs"
                v-on="on"
                ><v-icon>mdi-sync</v-icon>
                Sincronizar
              </v-btn>
            </template>
            <span>Sincronizar Com Chessgestão</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingSave" @click="saveTeam" x-large color="primary">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BarTitle from "@/pages/Components/BarTitle.vue";
import { mapActions } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    team: {
      type: Object,
      default: null,
    },
  },
  components: {
    BarTitle,
  },
  data() {
    return {
      dialog: false,
      loading:false,
      disabledCard:false,
      loadingSave:false,
      headers: [
        { text: "NOME", value: "name" },
        { text: "FUNCAO", value: "employee_role.description" },
      ],
      employees: [],
      newTeamName: "",
      selectedEmployees: [],
    };
  },
  mounted() {
    // this.loadEmployees();
  },
  watch: {
    value(newVal) {
      this.dialog = newVal;
      if (newVal) {
        if (this.team) {
          this.newTeamName = this.team.name;
          this.selectedEmployees = this.team.employees;
        } else {
          this.newTeamName = "";
          this.selectedEmployees = [];
        }
        this.getEmployees();
      }
    },
    dialog(newVal) {
      this.$emit("input", newVal);
    },
  },
  computed: {
    title() {
      return this.team ? "Editar Equipe" : "Nova Equipe";
    },
  },
  methods: {
    ...mapActions("MeteringMop", [
      "syncEmployee",
      "loadEmployees",
      "storeTeam",
      "updateTeam",
    ]),
    saveTeam() {
      if (!this.newTeamName) {
        this.$toast.error("O nome da equipe é obrigatório");
        return;
      }
      const teamData = {
        id: this.team ? this.team.id : null,
        name: this.newTeamName,
        employees: this.selectedEmployees,
      };

      if (this.team) {
        //update
        this.disabledCard = true;
        this.loadingSave = true;
        this.updateTeam(teamData)
          .then((response) => {
            this.$emit("refresh", response.data);
            this.$toast.success("Equipe atualizada !");
            this.dialog = false;
          })
          .finally(() => {
            this.loadingSave = false;
            this.disabledCard = false;

          });
      } else {
        //create
        this.loadingSave = true;
        this.disabledCard = true;
        this.storeTeam(teamData)
          .then((response) => {
            this.$emit("refresh", response.data);
            this.$toast.success("Equipe criada !");
            this.dialog = false;
          })
          .finally(() => {
            this.loadingSave = false;
            this.disabledCard = false;
          });
      }
    },
    getEmployees() {
      this.loading = true;
      this.disabledCard = true;
      this.loadEmployees().then((response) => {
        this.employees = response.data;
      }).finally(() => {
        this.loading = false;
        this.disabledCard = false;
      });
    },
    syncWithChessgestao() {
      this.syncEmployee().then((response) => {
        this.employees = response.data;
      });
    },
    search(){

    }
  },
};
</script>

<style scoped></style>
